import styled from '@emotion/styled';

const NoSearchResults = styled('h4')(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 400,
}));

export default NoSearchResults;
